import * as React from "react";
const ContractView = React.lazy(() => import("./ContractViewContainer"));

export { ContractView };
